module.exports = __webpack_public_path__ + "img/cloggedcatchbasin_attached.a45599ab.svg";